import { API_BASE_URL, HEADERS_WITH_TOKEN } from '../../../services/api/BaseUrl'

export const getBranchOfficesByCompany = (id) =>
  fetch(
    `${API_BASE_URL}/companies/branch-offices/${id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  .then(res => res.json())